"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ParameterError = exports.AuthenticationError = exports.APIError = void 0;
var APIError = /** @class */ (function (_super) {
    __extends(APIError, _super);
    function APIError(_a) {
        var status = _a.status, message = _a.message, statusText = _a.statusText, _b = _a.timeout, timeout = _b === void 0 ? 0 : _b;
        var _this = this;
        if (message === undefined) {
            message = "UnDefined!";
        }
        _this = _super.call(this, message) || this;
        _this.status = status;
        _this.message = message;
        _this.statusText = statusText;
        _this.timeout = timeout;
        return _this;
    }
    APIError.prototype.toString = function () {
        return "APIError is " + this.message + " and Status is " + this.statusText;
    };
    return APIError;
}(Error));
exports.APIError = APIError;
var AuthenticationError = /** @class */ (function (_super) {
    __extends(AuthenticationError, _super);
    function AuthenticationError(_a) {
        var message = _a.message;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        return _this;
    }
    return AuthenticationError;
}(Error));
exports.AuthenticationError = AuthenticationError;
var ParameterError = /** @class */ (function (_super) {
    __extends(ParameterError, _super);
    function ParameterError(_a) {
        var message = _a.message;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        return _this;
    }
    return ParameterError;
}(Error));
exports.ParameterError = ParameterError;
//# sourceMappingURL=errors.js.map


// WEBPACK FOOTER //
// ./app/lib/smartorg-api/errors.js